import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import TitleOutlinedIcon from "@mui/icons-material/TitleOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { hasDetailValue } from "../../utils/detailUtils";

const iconMap = {
  id: SettingsOutlinedIcon,
  category: ArticleOutlinedIcon,
  title: TitleOutlinedIcon,
  person: PersonOutlineIcon,
  calendar: CalendarTodayOutlinedIcon,
  phone: PhoneOutlinedIcon,
  email: EmailOutlinedIcon,
  link: LinkOutlinedIcon,
  info: InfoOutlinedIcon,
};

function InfoRow({ label, value, icon = "info", badge, myanmar = false }) {
  if (!hasDetailValue(value) && !badge) return null;

  const Icon = iconMap[icon] || InfoOutlinedIcon;
  const valueClassName = [
    "detail-info-value",
    myanmar ? "detail-info-value--myanmar" : "",
    badge ? `detail-info-badge detail-info-badge--${badge}` : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="detail-info-row">
      <div className="detail-info-row-left">
        <span className="detail-info-row-icon">
          <Icon fontSize="small" />
        </span>
        <span className="detail-info-label">{label}</span>
      </div>
      <div className="detail-info-row-value">
        <span className={valueClassName} lang={myanmar ? "my" : undefined}>
          {value}
        </span>
      </div>
    </div>
  );
}
export default function DetailInfoSidebar({
  infoTitle = "Article Information",
  infoItems = [],
  quickActions = [],
}) {
  const visibleItems = infoItems.filter(
    (item) => hasDetailValue(item.value) || item.badge
  );
  const visibleActions = quickActions.filter((action) => action.label);

  return (
    <aside className="detail-sidebar">
      {visibleItems.length > 0 && (
        <div className="detail-sidebar-card">
          <div className="detail-sidebar-card-head">
            <span className="detail-sidebar-card-icon detail-sidebar-card-icon--purple">
              <InfoOutlinedIcon fontSize="small" />
            </span>
            <h2>{infoTitle}</h2>
          </div>
          <div className="detail-info-list">
            {visibleItems.map((item) => (
              <InfoRow key={item.label} {...item} />
            ))}
          </div>
        </div>
      )}

      {visibleActions.length > 0 && (
        <div className="detail-sidebar-card">
          <div className="detail-sidebar-card-head">
            <span className="detail-sidebar-card-icon detail-sidebar-card-icon--blue">
              <BoltOutlinedIcon fontSize="small" />
            </span>
            <h2>Quick Actions</h2>
          </div>
          <div className="detail-quick-actions">
            {visibleActions.map((action) => (
              <button
                key={action.label}
                type="button"
                className="detail-quick-action"
                onClick={action.onClick}
              >
                <span className="detail-quick-action-left">
                  {action.icon || <VisibilityOutlinedIcon fontSize="small" />}
                  {action.label}
                </span>
                <ChevronRightIcon fontSize="small" />
              </button>
            ))}
          </div>
        </div>
      )}
    </aside>
  );
}
